<template>
  <div class="grrz-dialog-wrap">
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title1" :btnTxt="btnTxt1" v-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && rightUsed[11]">
      <p class="tit">恭喜您，已获得<span  class="tit-names">个人认证</span>特权</p>
      <p class="des"><span class="des-in des-use">特权介绍：会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！</span></p>
      <div class="grrz-bg"><img class="grrz-bg-img" src="../../../../assets/imgs/pri-grrz.png"></div>
    </CvipDialog>
    <CvipDialog @btnClick="certification()" @close="close()" :title="title2" :btnTxt="btnTxt2" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && !rightUsed[11]">
      <p class="tit">恭喜您，已获得<span class="tit-names">个人认证</span>特权</p>
      <p class="des"><span class="des-in des-use">特权介绍：会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！</span></p>
      <div class="grrz-bg"><img class="grrz-bg-img" src="../../../../assets/imgs/pri-grrz.png"></div>
    </CvipDialog>
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" v-else>
      <p class="des">特权介绍：<span class="des-in">会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！</span></p>
      <div class="grrz-bg"><img class="grrz-bg-img" src="../../../../assets/imgs/pri-grrz.png"></div>
    </CvipDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CvipDialog from "./common/CvipDialog"
export default {
  name: 'grrzDialog',
  components: {
    CvipDialog
  },
  data () {
    return {
      // title: '开通黄金会员卡',
      title: '个人认证',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: '',
      btnTxt2: '免费认证'
    }
  },
  created () {
    window.clickLog && window.clickLog(`from=pc-cvip-grrz-tanchuang-show-${this.cvipMes.cvipstate}`)
  },
  methods: {
    // 点击支付按钮
    vipBuy () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-grrz-ljkt-${this.cvipMes.cvipstate}`)
      this.$emit('buyDialog')
    },
    close () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-grrz-close-${this.cvipMes.cvipstate}`)
      this.$emit('closeDialog')
    },
    certification (){
      this.$emit('authDialog');
      // window.open("//my.58.com/pro/jianlicert/")
      // window.location.reload()
    },
  },
  computed: mapGetters({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed' //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
  })
}
</script>

<style lang="scss" scoped>
.grrz-bg {
  width: 606px;
  height: 290px;
  margin: 20px auto 0;
  overflow: hidden;
}
.grrz-bg-img {
  width: 606px;
  height: 290px;
}
.des-in {
  font-size: 14px;
  color: #aaa;
}
.des-use {
  width: 100%;
  display: inline-block;
  text-align: center;
}
.tit {
  margin: 50px 0 8px;
  font-size: 24px;
  color: #333;
  line-height: 33px;
  text-align: center;
}
.tit {
  margin-top: 30px;
}
.tit-names {
  font-size: 24px;
  color: #D4B277;
  line-height: 33px;
}
</style>



// WEBPACK FOOTER //
// GrrzDialog.vue?8454f172